module.exports = __webpack_public_path__ + "media/images/lb/639-bd3038a90d0f6687accb334ac5847bf1.svg";